export default "__VITE_ASSET__CjSlY9yP__"